// A floor grille's figures (floorGrille.ts): what it is made of, its defaults,
// and its top over the floor — what a skirting and a bench's closed end stand
// on (benchSolids.ts). Kept apart so the benches read it without the grille's
// geometry, which reads the benches.
import type {
  FloorGrille,
  ProductInstance,
} from '../shared/types';

/** A grille's figures, every one filled in. */
export interface GrilleFigures {
  slatWidth: number;
  slatThickness: number;
  slatGap: number;
  battenWidth: number;
  battenThickness: number;
  battenSpacing: number;
}

/** What a grille is made of unless its card says otherwise (mm). */
export const GRILLE_DEFAULTS: GrilleFigures = {
  slatWidth: 65,
  slatThickness: 13,
  slatGap: 10,
  battenWidth: 65,
  battenThickness: 13,
  battenSpacing: 300,
};

/** A grille's figures with the defaults filled in. */
export function grilleFigures(g: FloorGrille | undefined): GrilleFigures {
  const pick = (v: number | undefined, d: number): number => (v != null && Number.isFinite(v) && v > 0 ? v : d);
  const D = GRILLE_DEFAULTS;
  return {
    slatWidth: pick(g?.slatWidth, D.slatWidth),
    slatThickness: pick(g?.slatThickness, D.slatThickness),
    slatGap: g?.slatGap != null && Number.isFinite(g.slatGap) && g.slatGap >= 0 ? g.slatGap : D.slatGap,
    battenWidth: pick(g?.battenWidth, D.battenWidth),
    battenThickness: pick(g?.battenThickness, D.battenThickness),
    battenSpacing: pick(g?.battenSpacing, D.battenSpacing),
  };
}

/** The top of a room's grille over its floor (mm): what a skirting and a
 *  bench's closed end stand on. 0 without one. */
export function grilleTop(room: Pick<ProductInstance, 'floorGrille'>): number {
  if (!room.floorGrille) return 0;
  const f = grilleFigures(room.floorGrille);
  return f.battenThickness + f.slatThickness;
}
